import { render, staticRenderFns } from "./DepartmentStatistics.vue?vue&type=template&id=3cf9d4f2&scoped=true"
import script from "./DepartmentStatistics.vue?vue&type=script&lang=js"
export * from "./DepartmentStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf9d4f2",
  null
  
)

export default component.exports